/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { accessInvitationsAcceptCreate } from '../fn/access-invitations/access-invitations-accept-create';
import { accessInvitationsAcceptCreate$FormData } from '../fn/access-invitations/access-invitations-accept-create-form-data';
import { AccessInvitationsAcceptCreate$FormData$Params } from '../fn/access-invitations/access-invitations-accept-create-form-data';
import { AccessInvitationsAcceptCreate$Params } from '../fn/access-invitations/access-invitations-accept-create';
import { accessInvitationsAcceptCreate$XWwwFormUrlencoded } from '../fn/access-invitations/access-invitations-accept-create-x-www-form-urlencoded';
import { AccessInvitationsAcceptCreate$XWwwFormUrlencoded$Params } from '../fn/access-invitations/access-invitations-accept-create-x-www-form-urlencoded';
import { accessInvitationsList } from '../fn/access-invitations/access-invitations-list';
import { AccessInvitationsList$Params } from '../fn/access-invitations/access-invitations-list';
import { accessProjectsInvitationsDestroy } from '../fn/access-invitations/access-projects-invitations-destroy';
import { AccessProjectsInvitationsDestroy$Params } from '../fn/access-invitations/access-projects-invitations-destroy';
import { accessProjectsInvitationsList } from '../fn/access-invitations/access-projects-invitations-list';
import { AccessProjectsInvitationsList$Params } from '../fn/access-invitations/access-projects-invitations-list';
import { accessProjectsInvitationsResendCreate } from '../fn/access-invitations/access-projects-invitations-resend-create';
import { AccessProjectsInvitationsResendCreate$Params } from '../fn/access-invitations/access-projects-invitations-resend-create';
import { BackendInvitationDto } from '../models/backend-invitation-dto';
import { BackendInvitationAcceptDto } from '../models/backend-invitation-accept-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiAccessInvitationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accessInvitationsList()` */
  static readonly AccessInvitationsListPath = '/api/access/invitations/';

  /**
   * Pending-приглашения для текущего юзера (по email).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessInvitationsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessInvitationsList$Response(
    params?: AccessInvitationsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendInvitationDto>>> {
    return accessInvitationsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Pending-приглашения для текущего юзера (по email).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessInvitationsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessInvitationsList(
    params?: AccessInvitationsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendInvitationDto>> {
    return this.accessInvitationsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendInvitationDto>>): Array<BackendInvitationDto> => r.body),
    );
  }

  /** Path part for operation `accessInvitationsAcceptCreate()` */
  static readonly AccessInvitationsAcceptCreatePath = '/api/access/invitations/accept/';

  /**
   * POST {token}: приём приглашения.
   *
   * Валидация:
   * - request.user.email == invitation.email (case-insensitive) → иначе 403;
   * - не expired (expires_at > now) → иначе 410 + помечаем как expired;
   * - status=pending → иначе 409;
   * - проект active;
   * - не member уже (защита от race) → если уже member → 409.
   *
   * Создаёт ProjectMembership, обновляет invitation.status=accepted, отправляет
   * email пригласившему.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessInvitationsAcceptCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accessInvitationsAcceptCreate$Response(
    params: AccessInvitationsAcceptCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendInvitationAcceptDto>> {
    return accessInvitationsAcceptCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * POST {token}: приём приглашения.
   *
   * Валидация:
   * - request.user.email == invitation.email (case-insensitive) → иначе 403;
   * - не expired (expires_at > now) → иначе 410 + помечаем как expired;
   * - status=pending → иначе 409;
   * - проект active;
   * - не member уже (защита от race) → если уже member → 409.
   *
   * Создаёт ProjectMembership, обновляет invitation.status=accepted, отправляет
   * email пригласившему.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessInvitationsAcceptCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accessInvitationsAcceptCreate(
    params: AccessInvitationsAcceptCreate$Params,
    context?: HttpContext,
  ): Observable<BackendInvitationAcceptDto> {
    return this.accessInvitationsAcceptCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendInvitationAcceptDto>): BackendInvitationAcceptDto => r.body),
    );
  }

  /**
   * POST {token}: приём приглашения.
   *
   * Валидация:
   * - request.user.email == invitation.email (case-insensitive) → иначе 403;
   * - не expired (expires_at > now) → иначе 410 + помечаем как expired;
   * - status=pending → иначе 409;
   * - проект active;
   * - не member уже (защита от race) → если уже member → 409.
   *
   * Создаёт ProjectMembership, обновляет invitation.status=accepted, отправляет
   * email пригласившему.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessInvitationsAcceptCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accessInvitationsAcceptCreate$XWwwFormUrlencoded$Response(
    params: AccessInvitationsAcceptCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendInvitationAcceptDto>> {
    return accessInvitationsAcceptCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * POST {token}: приём приглашения.
   *
   * Валидация:
   * - request.user.email == invitation.email (case-insensitive) → иначе 403;
   * - не expired (expires_at > now) → иначе 410 + помечаем как expired;
   * - status=pending → иначе 409;
   * - проект active;
   * - не member уже (защита от race) → если уже member → 409.
   *
   * Создаёт ProjectMembership, обновляет invitation.status=accepted, отправляет
   * email пригласившему.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessInvitationsAcceptCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accessInvitationsAcceptCreate$XWwwFormUrlencoded(
    params: AccessInvitationsAcceptCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendInvitationAcceptDto> {
    return this.accessInvitationsAcceptCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendInvitationAcceptDto>): BackendInvitationAcceptDto => r.body),
    );
  }

  /**
   * POST {token}: приём приглашения.
   *
   * Валидация:
   * - request.user.email == invitation.email (case-insensitive) → иначе 403;
   * - не expired (expires_at > now) → иначе 410 + помечаем как expired;
   * - status=pending → иначе 409;
   * - проект active;
   * - не member уже (защита от race) → если уже member → 409.
   *
   * Создаёт ProjectMembership, обновляет invitation.status=accepted, отправляет
   * email пригласившему.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessInvitationsAcceptCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accessInvitationsAcceptCreate$FormData$Response(
    params: AccessInvitationsAcceptCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendInvitationAcceptDto>> {
    return accessInvitationsAcceptCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * POST {token}: приём приглашения.
   *
   * Валидация:
   * - request.user.email == invitation.email (case-insensitive) → иначе 403;
   * - не expired (expires_at > now) → иначе 410 + помечаем как expired;
   * - status=pending → иначе 409;
   * - проект active;
   * - не member уже (защита от race) → если уже member → 409.
   *
   * Создаёт ProjectMembership, обновляет invitation.status=accepted, отправляет
   * email пригласившему.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessInvitationsAcceptCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accessInvitationsAcceptCreate$FormData(
    params: AccessInvitationsAcceptCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendInvitationAcceptDto> {
    return this.accessInvitationsAcceptCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendInvitationAcceptDto>): BackendInvitationAcceptDto => r.body),
    );
  }

  /** Path part for operation `accessProjectsInvitationsList()` */
  static readonly AccessProjectsInvitationsListPath = '/api/access/projects/{project_id}/invitations/';

  /**
   * Pending-приглашения в проекте (для manage_access).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsInvitationsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsInvitationsList$Response(
    params: AccessProjectsInvitationsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendInvitationDto>>> {
    return accessProjectsInvitationsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Pending-приглашения в проекте (для manage_access).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsInvitationsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsInvitationsList(
    params: AccessProjectsInvitationsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendInvitationDto>> {
    return this.accessProjectsInvitationsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendInvitationDto>>): Array<BackendInvitationDto> => r.body),
    );
  }

  /** Path part for operation `accessProjectsInvitationsDestroy()` */
  static readonly AccessProjectsInvitationsDestroyPath = '/api/access/projects/{project_id}/invitations/{iid}/';

  /**
   * DELETE: отзыв приглашения (status=revoked).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsInvitationsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsInvitationsDestroy$Response(
    params: AccessProjectsInvitationsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accessProjectsInvitationsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * DELETE: отзыв приглашения (status=revoked).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsInvitationsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsInvitationsDestroy(
    params: AccessProjectsInvitationsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.accessProjectsInvitationsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `accessProjectsInvitationsResendCreate()` */
  static readonly AccessProjectsInvitationsResendCreatePath =
    '/api/access/projects/{project_id}/invitations/{iid}/resend/';

  /**
   * POST: переотправка с новым токеном и сроком.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsInvitationsResendCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsInvitationsResendCreate$Response(
    params: AccessProjectsInvitationsResendCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accessProjectsInvitationsResendCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * POST: переотправка с новым токеном и сроком.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsInvitationsResendCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsInvitationsResendCreate(
    params: AccessProjectsInvitationsResendCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.accessProjectsInvitationsResendCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
